(function () {
  // Detecta o locale do Shopify (mais fiável do que window.location)
  // Vamos definir window.__shopLocale via Liquid (ver passo 3).
  function getLocale() {
    var l = (window.__shopLocale || "").toLowerCase();
    // normaliza pt-PT / pt-pt / en / en-GB / es-ES etc.
    if (l.startsWith("en")) return "en";
    if (l.startsWith("es")) return "es";
    return "pt"; // default
  }

  var DICTS = {
    en: {
      "Validação do Número de Identificação Fiscal da UE": "EU VAT ID Validation",
      "Caso tenha um registo VIES, por favor introduza o seu número de registo de IVA para que os impostos possam ser calculados corretamente no momento da finalização da compra. Caso não tenha registo VIES, pode avançar para o checkout diretamente.": "If you have a VIES registration, please enter your EU VAT number so taxes can be calculated correctly at checkout. If you don't have a VIES registration, you can proceed directly to checkout.",
      "Número de IVA da UE": "EU VAT number",
      "E-mail": "Email",
      "Validar": "Validate",
      "Eliminar": "Remove",
      "Parece que não possui registo VIES. Os impostos serão aplicados no momento do pagamento. Para prosseguir, apague o número de IVA que está no campo acima e vá para o checkout.": "It looks like you don’t have a VIES registration. Taxes will be applied at checkout. To continue, delete the VAT number from the field above, update the cart using the button and proceed to checkout.",
      "O serviço de validação da UE não está disponível. Por favor, contacte-nos.": "The EU validation service is not available. Please contact us.",
      "O seu número de identificação fiscal (IVA) foi validado com sucesso.": "Your VAT ID has been successfully validated.",
      "O número de identificação fiscal (IVA) foi excluído.": "The VAT ID has been removed.",
      "Por favor, introduza um código de país válido (ex.: DK, FR, DE,...)": "Please enter a valid country code (e.g., DK, FR, DE, …)",
      "Não nos é permitido emitir faturas isentas de IVA para empresas no mesmo país.": "We are not allowed to issue VAT-exempt invoices for companies in the same country.",
      "Por favor, introduza um número de identificação fiscal (NIF) válido da UE.": "Please enter a valid EU VAT ID.",
      "Por favor, introduza um endereço de e-mail válido.": "Please enter a valid email address.",
      "VAT ID country and shipping country do not match.": "VAT ID country and shipping country do not match."
    },
    es: {
      "Validação do Número de Identificação Fiscal da UE": "Validación del NIF-IVA de la UE",
      "Caso tenha um registo VIES, por favor introduza o seu número de registo de IVA para que os impostos possam ser calculados corretamente no momento da finalização da compra. Caso não tenha registo VIES, pode avançar para o checkout diretamente.": "Si tiene un registro VIES, por favor introduzca su número de IVA de la UE para que los impuestos se calculen correctamente al finalizar la compra. Si no tiene un registro VIES, puede proceder directamente al checkout.",
      "Número de IVA da UE": "Número de IVA de la UE",
      "E-mail": "Correo electrónico",
      "Validar": "Validar",
      "Eliminar": "Eliminar",
      "Parece que não possui registo VIES. Os impostos serão aplicados no momento do pagamento. Para prosseguir, apague o número de IVA que está no campo acima e vá para o checkout.": "Parece que no tiene registro en VIES. Los impuestos se aplicarán al finalizar el pago. Para continuar, borre el número de IVA del campo anterior, atualize el carrito en el botón y vaya al checkout.",
      "O serviço de validação da UE não está disponível. Por favor, contacte-nos.": "El servicio de validación de la UE no está disponible. Por favor, contáctenos.",
      "O seu número de identificação fiscal (IVA) foi validado com sucesso.": "Su NIF-IVA se ha validado correctamente.",
      "O número de identificação fiscal (IVA) foi excluído.": "El NIF-IVA se ha eliminado.",
      "Por favor, introduza um código de país válido (ex.: DK, FR, DE,...)": "Por favor, introduzca un código de país válido (p. ej.: DK, FR, DE, …)",
      "Não nos é permitido emitir faturas isentas de IVA para empresas no mesmo país.": "No se nos permite emitir facturas exentas de IVA para empresas en el mismo país.",
      "Por favor, introduza um número de identificação fiscal (NIF) válido da UE.": "Por favor, introduzca un NIF-IVA de la UE válido.",
      "Por favor, introduza um endereço de e-mail válido.": "Por favor, introduzca un correo electrónico válido.",
      "VAT ID country and shipping country do not match.": "El país del NIF-IVA y el país de envío no coinciden."
    }
  };

  function normalizeText(s) {
    return (s || "").replace(/\s+/g, " ").trim();
  }

  function translateNodeText(root, dict) {
    if (!root || !dict) return;

    // 1) Traduz text nodes (inclui mensagens que aparecem em divs/spans)
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var original = normalizeText(node.nodeValue);
      if (!original) continue;
      if (dict[original]) node.nodeValue = node.nodeValue.replace(original, dict[original]);
    }

    // 2) Traduz placeholders e atributos relevantes
    var vatInput = root.querySelector("#VatId");
    if (vatInput && vatInput.getAttribute("placeholder")) {
      var ph = normalizeText(vatInput.getAttribute("placeholder"));
      if (dict[ph]) vatInput.setAttribute("placeholder", dict[ph]);
    }

    var emailInput = root.querySelector("#exemptify_email");
    if (emailInput && emailInput.getAttribute("placeholder")) {
      var eph = normalizeText(emailInput.getAttribute("placeholder"));
      if (dict[eph]) emailInput.setAttribute("placeholder", dict[eph]);
    }

    // 3) Alguns scripts criam botões/inputs dinamicamente — tenta traduzir labels comuns
    root.querySelectorAll("button, input[type='button'], input[type='submit'], a").forEach(function (el) {
      var t = normalizeText(el.textContent || el.value || "");
      if (dict[t]) {
        if (el.tagName === "INPUT") el.value = dict[t];
        else el.textContent = dict[t];
      }
    });
  }

  function run() {
    var locale = getLocale();
    if (locale === "pt") return; // PT é o original
    var dict = DICTS[locale];
    if (!dict) return;

    var snippet = document.getElementById("ExemptifyCartValidationSnippet");
    if (!snippet) return;

    // traduz o que já existir
    translateNodeText(snippet, dict);

    // traduz o que for aparecendo depois (mensagens/erros/botões)
    var obs = new MutationObserver(function () {
      translateNodeText(snippet, dict);
    });
    obs.observe(snippet, { childList: true, subtree: true, characterData: true });
  }

  // garante que corre após o DOM estar pronto
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
})();
